<template>
  <div :class="componentClassName">
    <a-page-heading>営業時間設定</a-page-heading>
    <a-select-field
      v-if="companyID === POINT && companyIDList.length !== 0"
      id="-companyId"
      v-model="selectedCompanyID"
      :options="companyIDList"
      :searchable="true"
    />
    <m-section>
      <m-action-card title="対象の電話番号" icon="phone-setting" class="m-action-card__select-tel-number">
        <a-select-field
          id="phonenumberList"
          v-model="selectedTelNumber"
          :options="phonenumberList"
          :searchable="true"
        />
      </m-action-card>
    </m-section>

    <m-section>
      <m-action-card :id="idName[1]" title="営業時間設定" header-border no-header-margin icon="clock">
        <m-data-list :data="businessList" />
        <div v-if="canSettingBusinessHours" class="m-action-card__footer-actions">
          <a-button
            id="business_hours_setting_edit"
            variant="fill"
            color="grey"
            size="small"
            icon="edit"
            label="編集"
            @click="handleEditBusinessHourSetting"
          />
        </div>
      </m-action-card>
    </m-section>

    <m-section>
      <m-action-card :id="idName[2]" title="休日設定" header-border no-header-margin icon="clock-remove">
        <m-data-list-holiday :data="holidayList" />
        <div v-if="canSettingHoliday" class="m-action-card__footer-actions">
          <a-button
            id="holiday_hours_setting_edit"
            variant="fill"
            color="grey"
            size="small"
            icon="edit"
            label="編集"
            @click="handleEditHolidaySetting"
          />
        </div>
      </m-action-card>
    </m-section>

    <!-- <m-section>
      <m-action-card title="特別営業日設定" header-border no-header-margin icon="calendar">
        <m-data-list :data="specialBusinessList" />
        <div class="m-action-card__footer-actions">
          <a-button
            variant="fill"
            color="grey"
            size="small"
            icon="edit"
            label="編集"
            class="t-setting-business-list__edit-button"
            @click="handleEditSpecialBusinessDaySetting"
          />
        </div>
      </m-action-card>
    </m-section> -->

    <m-section>
      <m-action-card :id="idName[3]" title="営業時間外の対応" header-border no-header-margin icon="calendar-setting">
        <m-data-list class="t-setting-business-list__outsitde-hours-list" :data="outsideBusinessList" />
        <div v-if="canSettingResponse" class="m-action-card__footer-actions">
          <a-button
            id="out_of_business_hours_setting_edit"
            variant="fill"
            color="grey"
            size="small"
            icon="edit"
            label="編集"
            @click="handleEditOutsideBusinessHourSetting"
          />
        </div>
      </m-action-card>
    </m-section>

    <m-section>
      <m-action-card :id="idName[4]" title="例外日の対応" header-border no-header-margin icon="calendar-setting">
        <m-data-list class="t-setting-business-list__outsitde-hours-list" :data="exceptionDayResponseData" />
        <div v-if="canSettingResponse" class="m-action-card__footer-actions">
          <a-button
            id="out_of_exception_day_setting_edit"
            variant="fill"
            color="grey"
            size="small"
            icon="edit"
            label="編集"
            @click="handleEditExceptionDayResponseSetting"
          />
        </div>
      </m-action-card>
    </m-section>

    <m-section>
      <m-action-card :id="idName[5]" title="休憩時間の対応" header-border no-header-margin icon="calendar-setting">
        <m-data-list class="t-setting-business-list__break-time-hours-list" :data="breakTimeHourList" />
        <div v-if="canSettingBreakTimeResponse" class="m-action-card__footer-actions">
          <a-button
            id="break_hours_setting_edit"
            variant="fill"
            color="grey"
            size="small"
            icon="edit"
            label="編集"
            @click="handleEditBreakTimeHourSetting"
          />
        </div>
      </m-action-card>
    </m-section>
  </div>

  <!-- Info, Erro Modal -->
  <teleport to="body">
    <o-modal
      id="settingBusinessList_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import MSection from '@/components/molecules/section';
import MDataList from '@/components/molecules/data-list';
import MDataListHoliday from '@/components/molecules/data-list-holiday';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { PERMISSIONS_FRONTEND } from '@/libs/constants';
import { POINT, HOLIDAY_TYPE } from '@/libs/constants';
import { utils } from '@/common/utils.js';

export default {
  name: 't-setting-business-list',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    MDataList,
    MDataListHoliday,
  },
  mixins: [customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    specialBusinessList: {
      type: Array,
      default: new Array(0),
    },
    companyID: {
      type: String,
      default: '',
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      selectedCompanyID: '',
      companyIDList: [],
      authInfo: this.$store.state.user.authInfo,
      businessList: [],
      breakTimeHourList: [],
      holidayList: [],
      outsideBusinessList: [],
      exceptionDayResponseData: [],
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      POINT,
      idName: [],
      selectedTelNumber: '',
      phonenumberList: [],
      numberNameList: {},
      selectedNumberName: '',
      loadingFlags: [false, false, false, false, false],
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-business-list');
      return `${baseClassName} ${this.class}`.trim();
    },
    canSettingBusinessHours() {
      return PERMISSIONS_FRONTEND['ServiceConditionHours'][this.authInfo];
    },
    canSettingHoliday() {
      return PERMISSIONS_FRONTEND['ServiceConditionHoliday'][this.authInfo];
    },
    canSettingResponse() {
      return PERMISSIONS_FRONTEND['ServiceConditionResponse'][this.authInfo];
    },
    canSettingBreakTimeResponse() {
      return PERMISSIONS_FRONTEND['ServiceConditionBreakTimeResponse'][this.authInfo];
    },
    dayLabel() {
      return {
        settingMonday: '月曜日',
        settingTuesday: '火曜日',
        settingWednesday: '水曜日',
        settingThursday: '木曜日',
        settingFriday: '金曜日',
        settingSaturday: '土曜日',
        settingSunday: '日曜日',
      };
    },
    modeLabel() {
      return {
        'voice-guidance': 'ガイダンスを流して留守電',
        'voice-guidance-no-message': 'ガイダンスを流して切断',
        transfer: '外線転送',
        voiceDX: 'COTOHA Voice DX Basic',
      };
    },
  },
  watch: {
    selectedCompanyID: async function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        if (this.companyID === POINT && this.selectedCompanyID !== this.$route.query.companyID) {
          await this.$router.push({ query: { companyID: this.selectedCompanyID } });
        }
        await this.getNumberList();
      }
      if (!newValue) {
        this.selectedCompanyID = oldValue;
      }
    },
    selectedTelNumber: function (val) {
      this.loadData();
      this.selectedNumberName = this.numberNameList[val] || '未設定';
    },
    loadingFlags: {
      handler: function (val) {
        this.setLoading(val[0] || val[1] || val[2] || val[2]);
      },
      deep: true,
    },
  },
  created() {
    for (let i = 1; i <= 5; i++) {
      this.idName[i] = 'h4-service-condition' + i;
    }

    if (this.companyID === POINT) {
      this.fetchCompanyIDListHandler();
    }
    this.selectedCompanyID = this.$route.query.companyID ? this.$route.query.companyID : this.companyID;
  },
  mounted() {},
  methods: {
    handleEditBusinessHourSetting() {
      if (this.companyID === POINT) {
        this.$router.push({
          name: 'ServiceConditionHours',
          params: { numberName: this.selectedNumberName, telNumber: this.selectedTelNumber },
          query: { companyID: this.selectedCompanyID },
        });
      } else {
        this.$router.push({
          name: 'ServiceConditionHours',
          params: { numberName: this.selectedNumberName, telNumber: this.selectedTelNumber },
        });
      }
    },
    handleEditHolidaySetting() {
      if (this.companyID === POINT) {
        this.$router.push({
          name: 'ServiceConditionHoliday',
          params: { numberName: this.selectedNumberName, telNumber: this.selectedTelNumber },
          query: { companyID: this.selectedCompanyID },
        });
      } else {
        this.$router.push({
          name: 'ServiceConditionHoliday',
          params: { numberName: this.selectedNumberName, telNumber: this.selectedTelNumber },
        });
      }
    },
    handleEditOutsideBusinessHourSetting() {
      if (this.companyID === POINT) {
        this.$router.push({
          name: 'ServiceConditionResponse',
          params: { numberName: this.selectedNumberName, telNumber: this.selectedTelNumber },
          query: { companyID: this.selectedCompanyID },
        });
      } else {
        this.$router.push({
          name: 'ServiceConditionResponse',
          params: { numberName: this.selectedNumberName, telNumber: this.selectedTelNumber },
        });
      }
    },
    handleEditExceptionDayResponseSetting() {
      if (this.companyID === POINT) {
        this.$router.push({
          name: 'ExceptionDayResponse',
          params: { numberName: this.selectedNumberName, telNumber: this.selectedTelNumber },
          query: { companyID: this.selectedCompanyID },
        });
      } else {
        this.$router.push({
          name: 'ExceptionDayResponse',
          params: { numberName: this.selectedNumberName, telNumber: this.selectedTelNumber },
        });
      }
    },
    handleEditBreakTimeHourSetting() {
      if (this.companyID === POINT) {
        this.$router.push({
          name: 'ServiceConditionBreakTimeResponse',
          params: { numberName: this.selectedNumberName, telNumber: this.selectedTelNumber },
          query: { companyID: this.selectedCompanyID },
        });
      } else {
        this.$router.push({
          name: 'ServiceConditionBreakTimeResponse',
          params: { numberName: this.selectedNumberName, telNumber: this.selectedTelNumber },
        });
      }
    },
    fetchCompanyIDListHandler: function () {
      this.postRequest('/companymgmt/getcompanyidlistCCCOnly', { withPoint: true })
        .then(e => {
          this.companyIDList = e.data;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('登録ユーザーの取得'));
        });
    },
    loadBusinessHoursList() {
      this.loadingFlags[0] = true;
      this.postRequest('/servicecondition/getbusinesshours', {
        companyID: this.selectedCompanyID,
        telNumber: this.selectedTelNumber,
      })
        .then(e => {
          this.loadingFlags[0] = false;
          this.businessList = [];
          function printTime(period) {
            let content = '営業時間：' + period.periods.join(' / ').replaceAll('-', ' - ');
            if (period.breakTimePeriods && period.breakTimePeriods.length > 0) {
              content += '<br />' + '休憩時間：' + period.breakTimePeriods.join(' / ').replaceAll('-', ' - ');
            }
            return content;
          }
          for (const period of e.currentPeriodList) {
            const label = this.dayLabel[period.label];
            const content = !period.active ? '休業日' : period.is24hours ? '24時間営業' : printTime(period);
            this.businessList.push({ label, content });
          }
        })
        .catch(() => {
          this.loadingFlags[0] = false;
          this.showErrorModal(messageContent.requireTry('登録ユーザーの取得'));
        });
    },
    loadHoliday() {
      this.loadingFlags[1] = true;
      this.postRequest('/servicecondition/getholiday', {
        companyID: this.selectedCompanyID,
        telNumber: this.selectedTelNumber,
      })
        .then(e => {
          this.loadingFlags[1] = false;
          this.holidayList = [];
          for (const index in e.currentHolidayList) {
            this.holidayList.push({
              label: `休日${parseInt(index) + 1}`,
              type: e.currentHolidayList[index]['type'] === HOLIDAY_TYPE.EXCEPTION ? '例外日' : '休業日',
              value: e.currentHolidayList[index]['value'],
            });
          }
          if (!this.holidayList.length) {
            this.holidayList.push({ label: '設定なし' });
          }
        })
        .catch(() => {
          this.loadingFlags[1] = false;
          this.showErrorModal(messageContent.requireTry('休日設定の取得'));
        });
    },
    loadBusinessHoursResponse() {
      this.loadingFlags[2] = true;
      this.postRequest('/servicecondition/business-hours-guidance-preload-data', {
        companyID: this.selectedCompanyID,
        telNumber: this.selectedTelNumber,
      })
        .then(e => {
          this.loadingFlags[2] = false;
          this.outsideBusinessList = [];
          const data = e.data;
          if (!data.mode) {
            this.outsideBusinessList.push({ label: '設定なし' });
            return;
          }
          this.outsideBusinessList.push({ label: '営業時間外の対応', content: this.modeLabel[data.mode] });
          if (data.mode === 'voice-guidance-no-message') {
            this.outsideBusinessList.push({ label: 'ガイダンス内容', content: data.outOfServiceGuidance1 });
            if (data.emailNotification) {
              this.outsideBusinessList.push({ label: 'メール通知', content: data.absenceMail });
            }
          } else if (data.mode === 'voice-guidance') {
            this.outsideBusinessList.push({ label: 'ガイダンス内容', content: data.outOfServiceGuidance2 });
          } else {
            const label = data.voiceDXData.find(item => item.value === data.phoneNumber)?.label || data.phoneNumber;
            this.outsideBusinessList.push({ label: '電話番号', content: label });
          }
        })
        .catch(() => {
          this.loadingFlags[2] = false;
          this.showErrorModal(messageContent.requireTry('営業時間の取得'));
        });
    },
    loadExceptionDayResponse() {
      this.loadingFlags[4] = true;
      this.postRequest('/servicecondition/exception-day-guidance-preload-data', {
        companyID: this.selectedCompanyID,
        telNumber: this.selectedTelNumber,
      })
        .then(e => {
          this.loadingFlags[4] = false;
          this.exceptionDayResponseData = [];
          const data = e.data;
          if (!data.mode) {
            this.exceptionDayResponseData.push({ label: '設定なし' });
            return;
          }
          this.exceptionDayResponseData.push({ label: '例外日の対応', content: this.modeLabel[data.mode] });
          if (data.mode === 'voice-guidance-no-message') {
            this.exceptionDayResponseData.push({ label: 'ガイダンス内容', content: data.exceptionDayGuidance1 });
            if (data.emailNotification) {
              this.exceptionDayResponseData.push({ label: 'メール通知', content: data.absenceMail });
            }
          } else if (data.mode === 'voice-guidance') {
            this.exceptionDayResponseData.push({ label: 'ガイダンス内容', content: data.exceptionDayGuidance2 });
          } else {
            const label = data.voiceDXData.find(item => item.value === data.phoneNumber)?.label || data.phoneNumber;
            this.exceptionDayResponseData.push({ label: '電話番号', content: label });
          }
        })
        .catch(() => {
          this.loadingFlags[4] = false;
          this.showErrorModal(messageContent.requireTry('例外日設定の取得'));
        });
    },
    loadBreakTimeHourResponse() {
      this.loadingFlags[3] = true;
      this.postRequest('/servicecondition/break-time-hours-guidance-preload-data', {
        companyID: this.selectedCompanyID,
        telNumber: this.selectedTelNumber,
      })
        .then(e => {
          this.loadingFlags[3] = false;
          this.breakTimeHourList = [];
          const data = e.data;
          if (!data.mode) {
            this.breakTimeHourList.push({ label: '設定なし' });
            return;
          }
          this.breakTimeHourList.push({ label: '休憩時間の対応', content: this.modeLabel[data.mode] });
          if (data.mode === 'voice-guidance-no-message') {
            this.breakTimeHourList.push({ label: 'ガイダンス内容', content: data.breakTimeGuidance1 });
          } else if (data.mode === 'voice-guidance') {
            this.breakTimeHourList.push({ label: 'ガイダンス内容', content: data.breakTimeGuidance2 });
          } else {
            const label = data.voiceDXData.find(item => item.value === data.phoneNumber)?.label || data.phoneNumber;
            this.breakTimeHourList.push({ label: '電話番号', content: label });
          }
        })
        .catch(() => {
          this.loadingFlags[3] = false;
          this.showErrorModal(messageContent.requireTry('休憩時間の取得'));
        });
    },
    async getNumberList() {
      this.phonenumberList = [];
      this.numberNameList = {};
      if (utils.chkTrialCompanyID(this.selectedCompanyID)) {
        const telNumber = `${this.companyID}_TRIALPHONENUMBER`;
        this.phonenumberList.push({ value: telNumber, label: 'トライアルユーザーの方は外線番号が利用できません' });
        this.selectedTelNumber = telNumber;
      }
      await this.postRequest('/servicecondition/gettelnumberlist', { companyID: this.selectedCompanyID })
        .then(res => {
          if (res.status === 'failed') throw new Error(res.status);
          for (const item of res.data) {
            this.numberNameList[item.telNumber] = item.numberName;
            this.phonenumberList.push({ value: item.telNumber, label: `${item.numberName}（${item.telNumber}）` });
          }
          this.selectedTelNumber = this.$route.query.telNumber || this.phonenumberList[0].value;
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('電話番号一覧の取得'));
        });
    },
    loadData() {
      this.setLoading(true);
      this.loadBusinessHoursList();
      this.loadHoliday();
      this.loadBusinessHoursResponse();
      this.loadExceptionDayResponse();
      this.loadBreakTimeHourResponse();
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
  },
};
</script>
